import { Line } from 'vue-chartjs'
import { request } from '@/request'

export const LineChart = {
  extends: Line,
  data () {
    return {
      chartData: {
        labels: [],
        datasets: [{}]
      }
    }
  },
  props: ['url', 'options'],
  mounted () {
    if (this.$refs.canvas) {
      request
      .get(this.url)
      .then(r => {
        if (Object.keys(r).length > 0) {
          this.chartData = r
        }

        var gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

        gradient.addColorStop(0, 'rgba(210, 230, 139, 0.5)')
        gradient.addColorStop(0.5, 'rgba(210, 230, 139, 0.25)')
        gradient.addColorStop(1, 'rgba(210, 230, 139, 0)')

        this.chartData.datasets[0].label = 'Valores'
        this.chartData.datasets[0].borderColor = '#A1BE4D'
        this.chartData.datasets[0].pointBackgroundColor = 'white'
        this.chartData.datasets[0].borderWidth = 1
        this.chartData.datasets[0].pointRadius = 4
        this.chartData.datasets[0].pointHoverRadius = 8
        this.chartData.datasets[0].pointBorderWidth = 1
        this.chartData.datasets[0].pointBorderColor = 'black'
        this.chartData.datasets[0].backgroundColor = gradient

        this.renderChart(
          this.chartData,
          this.options
        )
      })
      .catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/LineChart.js